module.exports = __webpack_public_path__ + "f8236bbac2f216d490937305309645ea.svg";